import { createSlice } from "@reduxjs/toolkit";
const slice = createSlice({
    initialState: { json: "" },
    name: "editJsonWidgetReducers",
    reducers: {
        resetJsonWidgetReducers: (state) => {
            state.json = "";
        },
        setJsonWidgetReducers: (state, action) => {
            if (action.payload) {
                state.json = action.payload;
            }
        }
    }
});
export const editJsonWidgetReducers = slice.reducer;
export const { setJsonWidgetReducers, resetJsonWidgetReducers } = slice.actions;
